import { render, staticRenderFns } from "./DragAndDropTablet.vue?vue&type=template&id=af9daecc&scoped=true"
import script from "./DragAndDropTablet.vue?vue&type=script&lang=js"
export * from "./DragAndDropTablet.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropTablet.vue?vue&type=style&index=0&id=af9daecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9daecc",
  null
  
)

export default component.exports